<template>
    <div>
        <DebtActionButtons :pre-trial-comment.sync="preTrialComment" @createPreTrialNotice="createPreTrialNotice" />
        <AccountsDebtFilter :filter-model="filter" @resetFilter="resetFilter" @applyFilter="applyFilter" />
        <AccountsDebtTable :selected.sync="selected" :item-start.sync="itemStart" :items-per-page="itemsPerPage" :is-loading="isLoading" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import AccountsDebtFilter from '@/components/debts-info/accountsDebt/AccountsDebtFilter.vue';
import AccountsDebtTable from '@/components/debts-info/accountsDebt/AccountsDebtTable.vue';
import DebtActionButtons from '@/components/debts-info/DebtActionButtons.vue';
import AccountsService from '@/services/apiRequests/accounts.service';
import ActsService from '@/services/apiRequests/acts.service';

export default {
    name: 'AccountsDebt',
    components: { DebtActionButtons, AccountsDebtTable, AccountsDebtFilter },
    data: function() {
        return {
            itemStart: 0,
            itemsPerPage: 10,
            filter: {
                sum_debt: null,
                person_name: null,
                isServiceConnected: null,
                account_number: null,
                selectedDistrictRid: null,
                notice_status_type_rid: null,
                selectedAddress: {}
            },
            isLoading: false,
            selected: [],
            preTrialComment: ''
        };
    },
    provide: function() {
        return {
            saveAct: this.saveAct,
            getActPdf: this.getActPdf,
            getActSignInfo: this.getActSignInfo,
            postActSign: this.postActSign
        };
    },
    methods: {
        ...mapActions('accounts', ['setFilterOptions', 'getAccounts']),
        ...mapActions('base', ['showMessage']),
        applyFilter() {
            this.itemStart = 0;
            if (this.filter.sum_debt) {
                this.filter.sum_debt = Number(this.filter.sum_debt);
            }
            this.setFilterOptions(this.filter);
            this.fetchData();
        },
        resetFilter() {
            this.itemStart = 0;
            this.filter = {
                sum_debt: null,
                person_name: null,
                isServiceConnected: null,
                account_number: null,
                selectedDistrictRid: null,
                notice_status_type_rid: null,
                selectedAddress: {}
            };
            this.setFilterOptions(this.filter);
            this.fetchData();
        },
        async fetchData() {
            this.isLoading = true;
            const payload = {
                currentItem: this.itemStart,
                itemsPerPage: this.itemsPerPage
            };
            await this.getAccounts(payload);
            this.isLoading = false;
        },
        async createPreTrialNotice() {
            if (!this.selected.length) {
                await this.showMessage({ message: 'Выберите хотя бы одну позицию', color: 'error' });
                return;
            }
            const payload = {
                comment: this.preTrialComment,
                accounts: this.selected.map(account => account.record_id)
            };
            const response = await AccountsService.createPreTrialNotice(payload);
            if (response.successfull) {
                await this.showMessage({
                    message: 'Досудебное уведомление по выбранным позициям созданы. Для просмотра можно перейти в раздел “Досудебные кведомления”'
                });
            }
        },
        saveAct(payload) {
            return ActsService.addAccountAct(payload);
        },
        getActPdf(record_id) {
            const payload = { acts: [record_id] };
            return ActsService.getAccountActPDF(payload);
        },
        getActSignInfo(act_rid) {
            return ActsService.getAccountActInfoToSign(act_rid);
        },
        postActSign(payload) {
            return ActsService.postAccountActSign(payload);
        }
    },
    watch: {
        itemStart: {
            handler: function() {
                this.selected = [];
                this.fetchData();
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss"></style>
